import axios from 'axios';
import API_BASE_URL from '../config'; // Import de l'URL de base depuis config.js

// Création d'une instance Axios avec configuration de base
const api = axios.create({
  baseURL: API_BASE_URL, // Utilise l'URL définie dans config.js
});

// Intercepteur pour ajouter automatiquement le token JWT à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Récupère le token JWT depuis localStorage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // Ajoute le token dans l'en-tête Authorization
    } else {
      console.warn('Aucun token JWT trouvé dans localStorage.');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Fonction pour récupérer les questions d'un utilisateur spécifique
 * @param {string} userId ID de l'utilisateur
 * @returns {Promise} Promesse contenant les données des questions
 */
export const getQuestions = async (userId) => {
  if (!userId) {
    throw new Error('L\'ID utilisateur est requis pour récupérer les questions.');
  }

  try {
    const response = await api.get(`/api/questions/${userId}`); // Requête GET pour les questions
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des questions :', error.message);
    throw error; // Relance l'erreur pour que le composant qui appelle la fonction puisse la gérer
  }
};

/**
 * Fonction pour soumettre une réponse et mettre à jour les scores
 * @param {Object} data Données à envoyer au backend (userId, questionId, correct)
 * @returns {Promise} Promesse contenant les données mises à jour
 */
export const updateElo = async (data) => {
  try {
    const response = await api.post('/api/questions/update-elo', data); // Requête POST pour mettre à jour Elo
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour des scores :', error.message);
    throw error; // Relance l'erreur
  }
};

/**
 * Fonction pour récupérer le profil utilisateur
 * @returns {Promise} Promesse contenant les données de l'utilisateur
 */
export const getUserProfile = async () => {
  try {
    const response = await api.get('/api/auth/me'); // Requête GET pour récupérer le profil utilisateur
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du profil utilisateur :', error.message);
    throw error; // Relance l'erreur
  }
};

export default api;
